<span [class]="indicatie">
  <i></i>
  <div class="info">
    <h3>{{data.titel}}</h3>
    <div class="laag">Laag: 0 - {{data.laag | percent}}</div>
    <div class="matig">Matig: {{data.laag * 100 | number:'1.0-0'}} - {{data.matig | percent}}</div>
  </div>
</span>
<div>{{data.waarde | percent}}</div>
